import { FC, useEffect, useState } from "react";
import styles from "./AdminPanel.module.scss";
import { IService, IServiceCreate } from "../../types/service";
import {
  addService,
  deleteService,
  getDeletedService,
  getRestoreService,
  getServices,
} from "../../api/services";
import { ErrorPage } from "../../pages/ErrorPage/ErrorPage";
import Loader from "../Loader/Loader";
import deleteIcon from "../../images/icons/delete.svg";
import { Button } from "../ui";
import { Input } from "../ui/Input/Input";
import returnIcon from "../../images/icons/undo.svg";

export const AdminServices: FC<{ isDelete: boolean }> = ({ isDelete }) => {
  const [services, setServices] = useState<IService[]>([]);
  const [servicesDelete, setServicesDelete] = useState<IService[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  async function fetchData() {
    try {
      setIsLoading(true);
      const data: IService[] = await getServices();
      setServices(data.filter((item) => item.isDeleted === false));
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchDataDeleted() {
    try {
      setIsLoading(true);
      const data: IService[] = await getDeletedService();
      setServicesDelete(data);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
    fetchDataDeleted();
  }, []);

  async function handleDelete(id: number) {
    try {
      setIsLoading(true);
      await deleteService(id);
      fetchData();
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
      fetchData();
    }
  }

  async function handlerClub() {
    try {
      setIsLoading(true);
      const service: IServiceCreate = {
        serviceName: name,
        description: description,
      };
      await addService(service);
      fetchData();
    } catch {
      return <ErrorPage />;
    } finally {
      setName("");
      setDescription("");
      setIsLoading(false);
    }
  }
  async function handleRestore(id: number) {
    try {
      setIsLoading(true);
      const service = {
        serviceId: id,
      };
      await getRestoreService(service);
      fetchDataDeleted();
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }

  if (isLoading)
    return (
      <div className={styles.loader}>
        <Loader color="#ac2386" size={60} borderWidth={5} />
      </div>
    );

  return (
    <div className={styles.container}>
      {isDelete === false && (
        <div className={styles.block}>
          <div className={styles.block_old}>
            <div className={styles.parametr}>
              {services &&
                services.map((service) => (
                  <li className={styles.block_old_item} key={service.id}>
                    <p className={styles.block_old_text}>
                      {service.serviceName}
                    </p>
                    <p className={styles.block_old_description}>
                      {service.description}
                    </p>
                    <img
                      className={styles.block_old_icon}
                      src={deleteIcon}
                      alt="Icon delete"
                      onClick={() => handleDelete(service.id)}
                    />
                  </li>
                ))}
            </div>
          </div>
          <div className={styles.block_club}>
            <div>
              <Input
                label={"Servise Name"}
                type={"text"}
                id={""}
                placeholder={"Name..."}
                value={name}
                setValue={setName}
              />
              <Input
                label={"Beschreibung"}
                type={"text"}
                id={""}
                placeholder={"Beschreibung..."}
                value={description}
                setValue={setDescription}
              />
            </div>
            <div className={styles.Button}>
              <Button onClick={handlerClub}>Add</Button>
            </div>
          </div>
        </div>
      )}
      {isDelete === true &&
        (servicesDelete && servicesDelete.length > 0 ? (
          servicesDelete.map((service) => (
            <li className={styles.block_old_item} key={service.id}>
              <p className={styles.block_old_text}>{service.serviceName}</p>
              <p className={styles.block_old_description}>
                {service.description}
              </p>
              <img
                className={styles.block_old_icon}
                src={returnIcon}
                alt="Icon delete"
                onClick={() => handleRestore(service.id)}
              />
            </li>
          ))
        ) : (
          <p>Die Liste ist leer</p>
        ))}
    </div>
  );
};
